<div class = "card card-container" *ngIf ="values[0]">
  <div class="card-label px-1" *ngIf="hasLabel()">
      <mat-label> 
          <ng-switch [ngSwitch]="getLength()">
              <ng-container *ngSwitchCase="0">
                  <span translate>
                      {{title_none}}
                  </span>
              </ng-container>
              <ng-container *ngSwitchCase="1">
                  <span translate>
                      {{title_single}}
                  </span>
              </ng-container>
              <ng-container *ngSwitchDefault>
                  <span translate>
                      {{title_multiple}}
                  </span>
              </ng-container>
          </ng-switch>
      </mat-label>
  </div>

  <mat-radio-group    [disabled]  =   "isDisabled()" 
                      (change)    =   "onChange($event)" 
                      [(ngModel)] =   "currentValue"
                      [ngClass]   =   "{'vertical-radio-group':vertical}">
      <mat-radio-button   *ngFor="let radio of values" 
                          [value] = "radio">
                          {{radio.name}}
      </mat-radio-button>
  </mat-radio-group>
</div>          


